import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SdvorButtonComponent, SdvorSpinnerComponent } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { SdSearchboxSearchBarComponent } from './searchbox-search-bar.component';

@NgModule({
  imports: [NgIf, NgFor, AsyncPipe, ReactiveFormsModule, IconModule, SdvorSpinnerComponent, SdvorButtonComponent],
  declarations: [SdSearchboxSearchBarComponent],
  exports: [SdSearchboxSearchBarComponent],
})
export class SdvorSearchboxSearchBarModule {}
